export const ROLE = {
  ADMIN: 0,
  ASSESSOR: 1,
};
